export default {
	ADMIN: "Admin",
	MANAGER: "Manager",
	RECEPTIONIST: "Receptionist",
	USER: "User",
	HIDE: "Hide",
	BUILDER: "Builder",
	PROJECT_MANAGER: "Project_Manager",
};
